import React, { useEffect, useState } from 'react';
import "../Css/Contact.css";
import { IoIosCall } from "react-icons/io";
import { IoIosMail } from "react-icons/io";
import { SiGooglemaps } from "react-icons/si";
import Footer from "../Component/Footer/Footer";
import { MetaTags } from 'react-meta-tags';
import $ from "jquery"
import { message } from 'antd';
import { Slide } from 'react-awesome-reveal';

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [comment, setComment] = useState("");
  const [contact, setContact] = useState("");
   useEffect(()=>{
          window.scrollTo(0, 0);
      },[])
  const submitForm = (event,values) => {
    event.preventDefault();
    if (contact.length!==10) {
        message.error("Mobile Number Must Be Ten Digits")
      }else{
    // console.log("value", values)

    var body =
      "<!DOCTYPE html><html><head><title>Enquiry Lead</title></head><body><div style='font-family:Arial,sans-serif;max-width:600px;margin:0 auto;background-color:#f2f2f2;padding:20px'><h2 style='color:#821f40'>Seema's Resort</h2><p>Hello</p><p>Thank you for your interest in comment</p><p>Please check your comment which generated from website:</p><table cellpadding='5' style='margin:0'><tr><td style='text-align:left;color:#821f40'><strong>Name:</strong></td><td style='text-align:left'>" +
      name +
      '</td></tr><tr><td style="text-align:left;color:#821f40"><strong>Email Id:</strong></td><td style="text-align:left">' +
      email +
      '</td></tr><tr><td style="text-align:left;color:#821f40"><strong>Contact No:</strong></td><td style="text-align:left">' +
      contact +
      '</td></tr><tr><td style="text-align:left;color:#821f40"><strong>Message:</strong></td><td style="text-align:left">' +
      comment +
      "</td></tr></table><p style='font-weight:700'>Best regards,<br>Your Team at Seema's Resort</p></div></body></html>";

    $.post(
      "https://skdm.in/server/v1/send_lead_mail.php",
      {
        toEmail: "",
        fromEmail: "skdmlead@gmail.com",
        bccMail: "skdmlead@gmail.com",
        mailSubject: "New Customer Lead",
        mailBody: body,
        accountName: "jutiepie",
        accountLeadSource: "",
        accountLeadName: name,
        accountLeadEmail: email,
        accountLeadPhone: contact,
      },

      function (dataa, status) {
        console.log("data :" + dataa);
        console.log("name:" + values);
      }
    );

    message.success("Your Form has Submitted Our team will contact with You  soon.");
    // form.resetFields();
    // values.preventDefault();
    // return false;
    setName("");
    setEmail("");
    setContact("");
    setComment("");
}
  };
  return (
    <>

      <MetaTags>
        <title>Resort Near Neral | Seema Resort</title>
        <meta title="Resort Near Neral | Seema Resort" />
        <meta name="description" content="Seema Resort, a serene getaway, offers a relaxing experience with stunning views and excellent amenities. Resort near Neral." />
        <meta name="keywords" content="Best Resort in Mahabaleshwar, Top Resort with Rooms in Mahabaleshwar, Resort with Valley View in Mahabaleshwar, Resort with Premium Rooms in Mahabaleshwar, Best 3BHK Villa in Mahabaleshwar, Premium Villa in Mahabaleshwar, Family Resort in Mahabaleshwar, Resort near Mahabaleshwar" />
        <link rel="canonical" href="https://seemasresort.com/resort-near-neral" />
        <meta http-equiv="cache-control" content="no-cache" />
        <meta http-equiv="expires" content="0" />
        <meta http-equiv="pragma" content="no-cache" />
        <meta property="og:title" content=" Resort Near Neral | Seema Resort" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://seemasresort.com/" />
        <meta property="og:description" content="Seema Resort, a serene getaway, offers a relaxing experience with stunning views and excellent amenities. Resort near Neral." />
        <meta property="og:image" content="https://seemasresort.com/static/media/logo.png" />
      </MetaTags>

      <section className='Contact-Page-Section-Banner-Images'>
        <div className='Contact-Page-Section-Banner-Images-con'>
          <div>
            <h2 className='mt-5 ms-5'>Contact</h2>
          {/* <h2>Resort near Karjat</h2> */}
          </div>
        </div>
      </section>
      <div className="container mt-4 my-2 ">
<h1 className="text-start heading" style={{fontFamily:" var(---lato)"}}>Resort Near Neral </h1>
</div>
      <section className='Contact-Page-Form-And-Details-con'>
        <div className='container'>
          <div className='Contact-Page-Details-con'>
            <div className='row'>
              
              <div className='col-md-7'>
              <Slide>
                <div className='Contact-Page-Details-Info-con'>
                  <div className='Contact-Page-Details-Head-con'>
                    <h3>Contact with us</h3>
                    <p style={{textAlign:'justify'}}>        Welcome to Seema Resort, your perfect escape nestled in the peaceful surroundings near Neral. We are dedicated to providing an unforgettable experience for every guest, whether you're here for a relaxing retreat or an adventure. Your feedback and inquiries are important to us, and we’re always ready to assist.
                    </p>
                  </div>

                  <div className='Contact-Page-Details-contact-con'>
                    <div className='Contact-Page-Details-Icons-Info-con'>
                      <IoIosCall />
                      <div className='Contact-Page-Details-Info'>
                        <h4>Call us now</h4>
                        <a href="tel:7745852323" target='blank'>
                          <h5>7745852323</h5>
                        </a>
                      </div>
                    </div>

                    <div className='Contact-Page-Details-Icons-Info-con'>
                      <IoIosMail />
                      <div className='Contact-Page-Details-Info'>
                        <h4>Send email</h4>
                        <a href="mailto:seemaresort@gmail.com" target='blank'>
                          <h5>seemaresort@gmail.com</h5>
                        </a>
                      </div>
                    </div>

                    <div className='Contact-Page-Details-Icons-Info-con'>
                      <SiGooglemaps />
                      <div className='Contact-Page-Details-Info'>
                        <h4>Our location</h4>
                        <a href='https://maps.app.goo.gl/2ahTmuH3zp3EiWno7' target='blank'>
                          <h5>Karjat - Neral Rd, near panchawati, opp. dignity foundation, Neral, Jite, Maharashtra 410101</h5>
                        </a>
                      </div>
                    </div>

                  </div>
                </div>
                </Slide>
              </div>
             
              <div className='col-md-5'>
                <Slide direction='right'>
                <form onSubmit={submitForm}>
                <section className='Contact-page-Form-Con'>
                  <div className='Contact-page-Form-Head-Con'>
                    <h2>Get in Touch</h2>
                  </div>
                  <div className='Contact-Page-Form-Inputs-con'>
                    <div className='Contact-Page-Form-Inputs'>
                      <label for="fname">Enter name</label>
                      <div className='Like-to-pay-form-con-Card-Info-Input'>
                        <input type="text"  onChange={(e)=>{setName(e.target.value)}}
                        value={name} id="fname" name="fname" placeholder='Enter your name' />
                      </div>
                    </div>
                    <div className='Contact-Page-Form-Inputs'>
                      <label for="fname">Enter number</label>
                      <div className='Like-to-pay-form-con-Card-Info-Input'>
                        <input type="number" id="fname" onChange={(e)=>{setContact(e.target.value)}}
                        value={contact} name="fname" placeholder='Enter your phone number' />
                      </div>
                    </div>

                    <div className='Contact-Page-Form-Inputs'>
                      <label for="fname">Message</label>
                      <div className='Like-to-pay-form-con-Card-Info-Input'>
                        <textarea type="text" id="fname" onChange={(e)=>{setComment(e.target.value)}}
                        value={comment} name="fname" placeholder='Enter your message' />
                      </div>
                    </div>

                    <div className='Contact-Page-Form-button'>
                      <button>
                        Sent Message
                      </button>
                    </div>
                  </div>
                </section>
                </form>
                </Slide>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='Contact-Page-Map-Section'>
        <div className='container'>
          <div className='Contact-Page-Map-Section-con'>
            <div className='Contact-Page-Map-Head-Section-con'>
              <h2>View your location</h2>
            </div>
          <Slide direction='up'>
            <div className='Contact-Page-Map-Section-con-frem'>
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15088.760675331774!2d73.3268149!3d19.0113401!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7f08adbbef231%3A0xbb02d6172ec767d6!2sSeema&#39;s%20Resort%20%26%20Restaurant%20Neral-Karjat!5e0!3m2!1sen!2sin!4v1733472183073!5m2!1sen!2sin" width="100%" height="450" style={{border:'0'}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
            </Slide>
          </div>
        </div>
      </section>
      <div className="container my-5" style={{display:'none'}}>
        
        <p className="lead">
        Our Address
        Seema Resort
Near Neral, Maharashtra
Phone: +91-7745852323
Email: info@seemaresort.com

        </p>
        <p className="lead">
        Visit Us
        Seema Resort is located in one of the most tranquil and picturesque locations near Neral, Maharashtra. With lush greenery, refreshing air, and breathtaking views, our resort offers an idyllic environment for relaxation. Whether you’re seeking peace or adventure, Resort Near Neral guarantees a rejuvenating stay surrounded by nature’s beauty.

        </p>
        <p className="lead">
        How to Reach Us
        Reaching a Resort Near Neral is simple and convenient. Our resort is easily accessible by train, bus, or car, making it the perfect destination for a quick getaway. We are located a short distance from Neral railway station, and we offer private pick-up services to ensure a smooth and comfortable journey for our guests.

        </p>
        <p className="lead">
        Booking Inquiries
        Planning a stay at Seema Resort? Booking is easy! Call us at +91-7745852323 or send us an email at info@seemaresort.com, and our dedicated team will assist you with the best available options for your stay. Whether it’s for a romantic weekend, a family vacation, or a special event, we are here to help.

          </p>
          <p className="lead">
          Follow Us
          Use various social media channels to stay in touch with Seema Resort. Get the latest updates, promotional offers, and exciting news about our resort. We can’t wait to welcome you to the Resort near Neral, where your dream getaway awaits.

          </p>
         
      </div>
      <Footer />
    </>
  )
}

export default Contact